import Vue from 'vue'
import Router from 'vue-router'
import RouterConfig from './modules/index' // 引入业务逻辑模块
Vue.use(Router)
/**
* hidden: true                   如果hidden为true，菜单不会在侧边栏显示
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             侧边栏icon,
    roles: [1001, 1]             角色id, 超级管理员权限为1
  }
**/
export const constantRoutes = [
  {
    path: '/404',
    component: () => import('@/views/error-pages/404.vue'),
    hidden: true,
    meta: { title: '404' }
  },
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true,
    meta: { title: '登录' }
  },
  {
    path: '/365Login',
    component: () => import('@/views/login/365Login.vue'),
    hidden: true,
    meta: { title: '登录' }
  },
  {
    path: '/noticeList',
    component: () => import('@/views/system-notice/wechat.vue'),
    hidden: true,
    meta: { title: '公告列表' }
  },
  {
    path: '/certificatePreview',
    component: () => import('@/views/cert-preview/certificatePreview'),
    hidden: true,
    meta: {
      roles: [0, 1, 2, 3, 4, 5]
    }
  },
  {
    path: '/pptxFilePreview',
    component: () => import('@/views/pptx-file-preview/index.vue'),
    hidden: true,
    meta: {
      roles: [0, 1, 2, 3, 4, 5]
    }
  },
  {
    path: '/certWechatCreate',
    component: () => import('@/views/cert-wechat-create/index.vue'),
    hidden: true,
  },
]
export const activeDefaultRoute = { path: '/', redirect: '', hidden: true }

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [].concat(RouterConfig)

const createRouter = () => new Router({
  // mode: 'history', // 后端支持可开
  mode: 'hash', // 后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
